export const AUTH_KEY = 'aerial_auth';
export const AUTH_TARGET_KEY = 'aerial_auth_target';
export const COO_DASHBOARD_PATH = '/coo-dashboard';

export const AUTH_TARGETS = {
  app: 'app',
  cooDashboard: 'coo-dashboard',
};

export const ACCESS_CODE_TARGETS = {
  aerial2025: AUTH_TARGETS.app,
  aerial2026: AUTH_TARGETS.cooDashboard,
};

export function normalizeAuthTarget(target) {
  return target === AUTH_TARGETS.cooDashboard ? AUTH_TARGETS.cooDashboard : AUTH_TARGETS.app;
}

export function readStoredAuthState() {
  try {
    return {
      isAuthenticated: window.sessionStorage.getItem(AUTH_KEY) === 'true',
      target: normalizeAuthTarget(window.sessionStorage.getItem(AUTH_TARGET_KEY)),
    };
  } catch {
    return {
      isAuthenticated: false,
      target: AUTH_TARGETS.app,
    };
  }
}
